<script lang="ts">
	import type { LoadResult } from '@kestrel/server';
	import type { load } from './RetailerSelectionTeaserServer.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import ToLogin from '../../../components/teaser/small/ToLogin.svelte';
	import ToSignUp from '../../../components/teaser/small/ToSignUp.svelte';
	import OldToBooster from '../../../components/teaser/medium/OldToBooster.svelte';
	import ToBooster from '../../../components/teaser/medium/ToBooster.svelte';

	let { data }: { data: LoadResult<typeof load> } = $props();
	const teaserSize = 'MediaObject25';

</script>

{#if !data.disableArticleTeaser}
	{#if data.teaserType === TeaserType.NO_CONTENT || !data.teaserContent}
		<div data-testid="no-content-teaser-container"></div>
	{:else if data.teaserType === TeaserType.TO_LOGIN}
		<ToLogin
			teaserContent={data.teaserContent}
			teaserSize={teaserSize}
		/>
	{:else if data.teaserType === TeaserType.BOOSTER_TEASER}
		{#if data.showBoosterCampaignRedesign}
			<ToBooster
				teaserContent={data.teaserContent}
				teaserType={TeaserType.BOOSTER_TEASER}
			/>
		{:else}
			<OldToBooster
				teaserContent={data.teaserContent}
			/>
		{/if}
	{:else if data.teaserType === TeaserType.NON_UP_PLUS_BOOSTER_TEASER}
		{#if data.showBoosterCampaignRedesign}
			<ToBooster
				teaserContent={data.teaserContent}
				teaserType={TeaserType.NON_UP_PLUS_BOOSTER_TEASER}
			/>
		{/if}
	{:else}
		<ToSignUp
			teaserContent={data.teaserContent}
			teaserType={data.teaserType}
			teaserSize={teaserSize}
			teaserTouchPoint={data.teaserTouchPoint}
		/>
	{/if}
{/if}
